<template>
  <div class="card">
    <router-link tag="a" :to="{name: 'play', params: { slug: item.slug }}">
        <figure class="image">
            <img class="card-image" :src="'/images/plays/' + item.mainimage" :alt="item.title">
        </figure>
    </router-link>
    <div class="card-content">
        <div class="content">
            <h5 class="title is-4">
                <router-link tag="a" :to="{ name: 'play', params: { slug: item.slug }}">
                    {{ item.title }}
                </router-link>
            </h5>

            <div>
              <p v-if="item.blurbExcerpt" v-html="item.blurbExcerpt" />
              <p v-else v-html="truncatedBlurb(item.blurb)" />
            </div>
            
        </div>
    </div>
  </div>
</template>

<script>
//import mixins from '@/mixins/mixins';
// import Api from '@/config/Api'; // MCH added

//import AlertMeButton from './AlertMeButton';


export default {
    props: ['item'],
    methods: {
        truncatedBlurb(blurb) {
            var output = this.$options.filters.truncate(blurb, 150)
            // | truncate(160, '...')
            return output;
        }
    }
    /* components: {
        AlertMeButton,
        MaxPriceWidget
    }, */
    // mixins: [mixins],
   
    /*MCH START*/
    /* data() {
        return {
            rrpPrice: '8',
            // pricey: '',
        }
    }, */
    /*created() {
        Api().get('/productGroups')
            .then(response => {
                // this.productGroups = response.data.productGroups;

                console.log("AA:",this.productGroup.rrpPrice); 
                //this.$set(this.productGroup, 'rrpPrice', 0);
                //console.log("BB:",this.productGroup.rrpPrice); 
            });
    }*/
    /*MCH END*/


}
</script>

<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/cards/SidebarCard.vue